import { CSSProperties } from 'react';

type TextBackgroundColorProps = {
  color?: CSSProperties['color'];
  size?: number;
};

const TextBackgroundColor = ({ color, size }: TextBackgroundColorProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
    >
      <path
        fill="#6D6D82"
        d="M9 13.2688V11.7688L9.7337 11.2625L13.4185 14.7937L12.8935 15.5H11.3283C10.9141 15.5 10.5163 15.6594 10.2228 15.9406L8.98043 17.1313L7.30109 15.5219L8.54348 14.3313C8.83696 14.05 9.00326 13.6688 9.00326 13.2719L9 13.2688ZM19.3957 6.81875L14.3446 13.5625L11.0217 10.3781L18.0587 5.5375C18.0946 5.5125 18.137 5.5 18.1793 5.5C18.2348 5.5 18.287 5.52188 18.3261 5.55938L19.3728 6.5625C19.412 6.6 19.4348 6.65 19.4348 6.70312C19.4348 6.74375 19.4217 6.78437 19.3957 6.81875ZM11.3283 17H12.8935C13.3989 17 13.8717 16.7688 14.1652 16.375L20.6674 7.69375C20.8826 7.40625 21 7.05937 21 6.70312C21 6.25313 20.8141 5.82187 20.4815 5.50312L19.4315 4.49687C19.0989 4.17812 18.6489 4 18.1793 4C17.8076 4 17.4457 4.1125 17.1457 4.31875L8.08696 10.55C7.67609 10.8313 7.43478 11.2844 7.43478 11.7688V13.2688L6.00978 14.6344C5.66087 14.9687 5.55 15.4469 5.68043 15.8687L3.30652 18.1469C3.11087 18.3344 3 18.5875 3 18.8531V19C3 19.5531 3.4663 20 4.04348 20H6.80543C7.08261 20 7.34674 19.8938 7.54239 19.7063L8.61196 18.6812C9.05543 18.8062 9.55109 18.7 9.9 18.3656L11.3283 17ZM7.39239 17.7281L6.59022 18.5H5.15217L6.675 17.0406L7.39565 17.7312L7.39239 17.7281Z"
      />
      <rect x="3" y="21" width="18" height="2" fill={color} />
    </svg>
  );
};

export default TextBackgroundColor;
